<script lang="ts">
	//Design  system components
	import { Input } from '@Shelly/shelly-design-system';
	import { createEventDispatcher, onDestroy, onMount } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';

	export let value = '0';
	let min = 0,
		max = 5000;
	let isInvalid = false;

	onMount(() => {
		validateValue();
	});

	onDestroy(() => {
		dispatch('valueChange', { duration: value, isInvalid: false });
	});

	const dispatch = createEventDispatcher();
	const changeValue = (event: Event) => {
		const target = event.target as HTMLInputElement;
		value = target.value;

		validateValue();
	};

	const validateValue = () => {
		if (min <= +value && +value <= max && value !== '') {
			isInvalid = false;
		} else {
			isInvalid = true;
		}

		dispatch('valueChange', { duration: value, isInvalid });
	};

	const selectValue = (event: MouseEvent) => {
		const currentTarget = event.currentTarget as HTMLInputElement;
		currentTarget.select();
	};
</script>

<Input
	on:input={changeValue}
	on:click={selectValue}
	{value}
	type="number"
	size="m"
	icon="fa-solid fa-history"
	label="Value"
	error={isInvalid ? `Please select values between ${min} and ${max}` : null}
	info={$format('movement_limit_toast', { values: { min, max } })}
	id="input-arjrahe"
	aria-labelledby="input-arjrahe"
/>
